<template>
  <div class="mt-9 grid md:grid-cols-12">
    <div class="flex flex-col items-center sm:flex-row md:col-span-6 md:col-start-4">
      <div class="order-last mt-4 flex basis-1/2 flex-col items-center sm:order-none sm:mt-0">
        <h1 class="mb-4 text-h2">{{ t['w.basket.empty.title']() }}</h1>
        <Button :link="t['w.basket.empty.button.link']()" class="btn-rounded btn-lg" icon-name="arrow-right">{{ t['w.basket.empty.button.text']() }}</Button>
      </div>
      <img
        class="h-auto max-w-60 basis-1/2 rounded-2xl"
        width="240"
        height="200"
        src="~/assets/illustrations/empty-cart.svg"
        :alt="t['w.basket.empty.image_alt']()"
        :title="t['w.basket.empty.title']()"
      />
    </div>
    <div class="my-10 flex flex-col gap-4 md:col-span-8 md:col-start-3">
      <NuxtLink v-for="(item, index) in visibleItems" :key="index" :href="item.link">
        <div class="rounded-2xl border border-border-medium px-6 py-4 transition-[border-color] hover:border-border-active">
          <h2 class="flex items-center text-base font-medium">
            <Icon name="arrow-right" class="mr-1 size-5" />
            {{ item.title }}
          </h2>
          <p class="mt-2 text-base text-text-medium">{{ item.text }}</p>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as t from '~/messages'

const items = [
  { title: t['w.basket.empty.first.title'](), link: t['w.basket.empty.first.link'](), text: t['w.basket.empty.first.text']() },
  { title: t['w.basket.empty.second.title'](), link: t['w.basket.empty.second.link'](), text: t['w.basket.empty.second.text']() },
  { title: t['w.basket.empty.third.title'](), link: t['w.basket.empty.third.link'](), text: t['w.basket.empty.third.text']() },
  { title: t['w.basket.empty.fourth.title'](), link: t['w.basket.empty.fourth.link'](), text: t['w.basket.empty.fourth.text']() },
  { title: t['w.basket.empty.fifth.title'](), link: t['w.basket.empty.fifth.link'](), text: t['w.basket.empty.fifth.text']() },
]

const visibleItems = items.filter((item) => item.title && item.link)
</script>
